import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DtoDetailPiezometerMeasure from '../../dto/DtoDetailPiezometerMeasure'
import moment from 'moment'
import { Timeserie, IChart } from 'react-aquasys'
import i18n from 'simple-react-i18n'

class HistoryChartPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			width: 0
		}
	}

	componentDidMount() {
		this.setState({ width: this.refs.historyChart.offsetWidth })
	}

	getChart = () => {
		const data = this.props.piezometerMeasures.map((piezometerMeasure) => {
			return {
				x: parseInt(moment(piezometerMeasure.date).format('x')),
				y: piezometerMeasure.measure
			}
		})
		const historySerie = new Timeserie({ data: data, color: 'black', name: 'Historique' })

		return (
			<IChart height='200' series={ [historySerie] } />
		)
	}

	render() {
		return (
			<div className='col s12 m12 l12 no-margin no-padding white-background' ref='historyChart'>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ i18n.historicalChart }
				</div>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ this.getChart() }
				</div>
			</div>
		)
	}

}

HistoryChartPanel.propTypes = {
	piezometerMeasures: PropTypes.arrayOf(PropTypes.objectOf(DtoDetailPiezometerMeasure))
}

HistoryChartPanel.defaultProps = {
	piezometerMeasures: []
}

export default HistoryChartPanel



// WEBPACK FOOTER //
// ./src/station/components/piezometer/HistoryChartPanel.js